import useScrollWatcher from "../Shared/ScrollWatcher";
import "./thank-you-dw.css";
import { Link } from "react-router-dom";

function ThankYouPageDW() {
  const [tariffsRef, isTariffsVisible] = useScrollWatcher();
  return (
    <section
      data-watch
      data-watch-threshold="0.15"
      ref={tariffsRef}
      className={isTariffsVisible ? "tariffs _watcher-view" : "tariffs"}
      style={{ paddingBottom: 0 }}
    >
      <div className="tariffs__container">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100svh",
          }}
        >
          <div className="tariffs__body">
            <div className="tariffs__item item-tariffs thank-you-card">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexFlow: "column",
                }}
              >
                <div className="popup__img">
                  <img src="img/tick.svg" alt="tick" />
                </div>
                <div className="popup__title">Дякуємо за довіру</div>
                <div className="popup__text">Запрошуємо на наш сайт</div>
                <Link
                  to="https://scout.com.ua/"
                  className={"header__btn button"}
                  style={{ marginTop: "20px" }}
                >
                  Перейти
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ThankYouPageDW;
